export default __webpack_public_path__ + "f1239df98893d2d84bc4e34746d690d5.svg";